import {createAction, props} from '@ngrx/store';
import {Product as Entity} from './product.model';
import {IPage, ITableSort, IResultWithPageInfo} from "src/app/store/app-store.interfaces";

import { Criteria } from "src/app/store/app-store.types";

export const loadAndSelect = createAction(
  '[Product] Load And Select Product',
  props<{ productId: number, correlationId?: string }>()
);

export const loadAndSelectIfNecessary = createAction(
  '[Product] Load And Select Product If Necessary',
  props<{ productId: number, correlationId?: string }>()
);

export const loadAndSelectSuccess = createAction(
  '[Product] Load And Select Product Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const loadAndSelectFailure = createAction(
  '[Product] Load And Select Product Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const clone = createAction(
  '[Product] Clone Product',
  props<{ entity: Entity, correlationId?: string }>()
);

export const cloneSuccess = createAction(
  '[Product] Clone Product Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const cloneFailure = createAction(
  '[Product] Clone Product Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const load = createAction(
  '[Product] Load Products',
  props<{ criteria?: Criteria, correlationId?: string }>()
);

export const loadSuccess = createAction(
  '[Product] Load Products Success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const addToStore = createAction(
  '[Product] Add Products To Store',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const loadFailure = createAction(
  '[Product] Load Products Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const loadSingleIfNecessary = createAction(
  '[Product] Load Single Products if necessary',
  props<{ entityId: number, criteria?: Criteria, correlationId?: string }>()
);

export const loadSingle = createAction(
  '[Product] Load Single Product',
  props<{ entityId: number, criteria?: Criteria, correlationId?: string }>()
);

export const loadSingleSuccess = createAction(
  '[Product] Load Single Product Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const loadSingleFailure = createAction(
  '[Product] Load Single Product Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const loadPage = createAction(
  '[Product] Load Paginated Products',
  props<{ page: IPage, criteria?: Criteria, correlationId?: string }>()
);

export const loadPageSuccess = createAction(
  '[Product] Load Paginated Products Success',
  props<{ resultWithPageInfo: IResultWithPageInfo<Entity>, correlationId?: string }>()
);

export const loadPageFailure = createAction(
  '[Product] Load Paginated Products Failed',
  props<{ error: Error, correlationId?: string }>()
);

export const create = createAction(
  '[Product] Create Products',
  props<{ entity: Entity, correlationId?: string }>()
);

export const createSuccess = createAction(
  '[Product] Create Product Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const createFailure = createAction(
  '[Product] Create Product Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const createMany = createAction(
  '[Product] Create Many Products',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const createManySuccess = createAction(
  '[Product] Create Many Products Success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const createManyFailure = createAction(
  '[Product] Create Many Products Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const update = createAction(
  '[Product] Update Product',
  props<{ entity: Entity, correlationId?: string }>()
);

export const updateSuccess = createAction(
  '[Product] Update Product Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const updateFailure = createAction(
  '[Product] Update Product Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const updateMany = createAction(
  '[Product] Update Many Products',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const updateManySuccess = createAction(
  '[Product] Update Many Products Success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const updateManyFailure = createAction(
  '[Product] Update Many Products Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const remove = createAction(
  '[Product] Remove Product',
  props<{ entityId: number, correlationId?: string }>()
);

export const removeSuccess = createAction(
  '[Product] Remove Product Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const removeFailure = createAction(
  '[Product] Remove Product Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const deselectAll = createAction(
  '[Product] Deselect All Entities'
);

export const deselectEntities = createAction(
  '[Product] Deselect Entities',
    props<{ entities: Entity[] }>()
);

export const deselectEntity = createAction(
  '[Product] Deselect Specific Entity',
  props<{ entityId: number }>()
);

export const setCurrentEntity = createAction(
  '[Product] Set Current Entity',
  props<{ entity: Entity }>()
);

export const setCurrentEntityId = createAction(
  '[Product] Set Current Entity Id',
  props<{ entityId: number }>()
);

export const selectEntity = createAction(
  '[Product] Select Entities by Ids',
  props<{ entityIds: number[] }>()
);

export const selectEntities = createAction(
  '[Product] Select Entities',
  props<{ entities: Entity[] }>()
);

export const setPaginationSettings = createAction(
  '[Product] Set Pagination Settings',
  props<{
    page: IPage,
  }>()
);

export const setSortSettings = createAction(
  '[Product] Set Sort Settings',
  props<{ tableSort: ITableSort }>()
);

export const getTotalProductCount = createAction(
  '[Product] Get All Products'
);

export const updateTotalProductCount = createAction(
  '[Product] Update Total Product Count',
  props<{ count: number }>()
);

export const getTotalProductCountFailed = createAction(
  '[Product] Get Total Product Count Failed',
  props<{ error: Error, correlationId?: string }>()
);

export const getTotalProductColours = createAction(
  '[Product] Get All Product Colours'
);

export const getTotalProductColoursSuccess = createAction(
  '[Product] Get All Product Colours Success',
  props<{ productColours: string[], correlationId?: string }>()
);

export const getProductExternalCategories = createAction(
  '[Product] Get All Product External Categories'
);

export const getProductExternalCategoriesSuccess = createAction(
  '[Product] Get All Product External Categories Success',
  props<{ productExternalCategories: string[], correlationId?: string }>()
);

export const getProductExternalCategoriesFailure = createAction(
  '[Product] Get All Product External Categories Failed',
  props<{ error: Error, correlationId?: string }>()
);

export const ProductActions = {
  loadPage,
  loadPageSuccess,
  loadPageFailure,
  load,
  loadSuccess,
  loadFailure,
  loadSingle,
  loadSingleSuccess,
  loadSingleFailure,
  create,
  createSuccess,
  createFailure,
  createMany,
  createManySuccess,
  createManyFailure,
  update,
  updateSuccess,
  updateFailure,
  updateMany,
  updateManySuccess,
  updateManyFailure,
  remove,
  removeSuccess,
  removeFailure,

  clone,
  cloneSuccess,
  cloneFailure,
  setCurrentEntity,
  setCurrentEntityId,
  deselectAll,
  deselectEntities,
  selectEntity,
  selectEntities,

  setPaginationSettings,
  setSortSettings,

  loadSingleIfNecessary,
  loadAndSelect,
  loadAndSelectIfNecessary,
  loadAndSelectSuccess,
  loadAndSelectFailure,

  getTotalProductCount,
  updateTotalProductCount,
  getTotalProductCountFailed,
  getTotalProductColours,
  getProductExternalCategories,
  getTotalProductColoursSuccess,
  getProductExternalCategoriesSuccess,
  getProductExternalCategoriesFailure,
  addToStore
};
